export const HELP_AUTOCOMPLETE_URL = 'https://';

export const EVENTS_WEBHOOKS = [
  'payment_created',
  'payment_rejected',
  'payment_paid',
  'payment_refunded',
  'payment_partially_refunded',
  'payment_edited',
  'payment_authorized',
  'payment_authentication_required',
];
